export const version = "bignumber/5.5.0";
//# sourceMappingURL=_version.js.map